import { translationExists, RoutablePage, interpolate, roundDownFormatter, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';

var CoinSwitcherTooltip = /** @class */ (function (_super) {
    __extends(CoinSwitcherTooltip, _super);
    function CoinSwitcherTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CoinSwitcherTooltip.prototype, "learnMoreLink", {
        get: function () {
            var translationKey = 'wandx.learn-more-link';
            if (translationExists(translationKey)) {
                return this.$t(translationKey);
            }
            return this.getFullHref({ route: RoutablePage.FAQ });
        },
        enumerable: false,
        configurable: true
    });
    CoinSwitcherTooltip.prototype.formatBalanceWithCurrency = function (isCash, balance, property) {
        if (property === void 0) { property = null; }
        var key = isCash ? 'wandx.cashcoins-short' : 'wandx.goldcoins-short';
        var defaultFormat = isCash ? '{amount} PHP' : '{amount} MFC';
        var value = property ? balance[property] : balance.balance;
        if (translationExists(key)) {
            return interpolate(this.$t(key), {
                amount: roundDownFormatter.format(value),
            });
        }
        return interpolate(defaultFormat, {
            amount: roundDownFormatter.format(value),
        });
    };
    Object.defineProperty(CoinSwitcherTooltip.prototype, "cashBalanceFormatted", {
        get: function () {
            return this.formatBalanceWithCurrency(true, this.cashBalance);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoinSwitcherTooltip.prototype, "freeCoinsBalanceFormatted", {
        get: function () {
            return this.formatBalanceWithCurrency(false, this.freeCoinsBalance);
        },
        enumerable: false,
        configurable: true
    });
    CoinSwitcherTooltip.prototype.formatBalanceValue = function (isCash, property) {
        var balance = isCash ? this.cashBalance : this.freeCoinsBalance;
        return this.formatBalanceWithCurrency(isCash, balance, property);
    };
    Object.defineProperty(CoinSwitcherTooltip.prototype, "formattedWithdrawable", {
        get: function () {
            return this.formatBalanceValue(true, 'withdrawable');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoinSwitcherTooltip.prototype, "formattedBonus", {
        get: function () {
            return this.formatBalanceValue(true, 'bonusBalance');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoinSwitcherTooltip.prototype, "formattedLocked", {
        get: function () {
            return this.formatBalanceValue(true, 'locked');
        },
        enumerable: false,
        configurable: true
    });
    CoinSwitcherTooltip.prototype.getTranslation = function (key, defaultValue) {
        return translationExists(key) ? this.$t(key) : defaultValue;
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], CoinSwitcherTooltip.prototype, "cashBalance", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], CoinSwitcherTooltip.prototype, "freeCoinsBalance", void 0);
    __decorate([
        Prop({ type: String, default: Currency.PHP }),
        __metadata("design:type", String)
    ], CoinSwitcherTooltip.prototype, "activeCurrency", void 0);
    CoinSwitcherTooltip = __decorate([
        Component({
            name: 'coin-switcher-tooltip',
        })
    ], CoinSwitcherTooltip);
    return CoinSwitcherTooltip;
}(Mixins(MagicConfigMixin)));

export default CoinSwitcherTooltip;
